import { PAGE_PAYMENT_PACKAGE } from "..";
import { apiInstance } from "../config/apiInstance";

export type GetPagePaymentPackageParams = {
  size?: number;
  page?: number;
  consecutive?: string;
  employerIdNumber?: string;
  packageStateId?: number;
  createdAtStart?: string;
  createdAtEnd?: string;
};

export type StatePackage = {
  id: number;
  code: string;
  name: string;
};

export type PaymentPackageItem = {
  consecutive: string;
  employerIdNumber: string;
  providerName: string;
  invoiceCount: number;
  totalValue: number;
  statePackage: StatePackage;
  createdAt: string;
  createdBy: string;
  electronicDocumentIds: number[];
};

export type GetPagePaymentPackageResponse = {
  content: PaymentPackageItem[];
  totalElements: number;
  number: number;
  size: number;
  contentSize: number;
};

export const getPagePaymentPackage = async (
  params?: GetPagePaymentPackageParams,
): Promise<GetPagePaymentPackageResponse> => {
  const response = await apiInstance.get<GetPagePaymentPackageResponse>(
    PAGE_PAYMENT_PACKAGE,
    {
      params: {
        ...params,
      },
    },
  );
  return response.data;
};
